import { jsx as _jsx } from "react/jsx-runtime";
import SeeWhatItsLike from '~/components/SeeWhatItsLike';
import { useLocaleKeys } from '~/i18n';
import img1 from './1.png';
import img2 from './2.png';
import img3 from './3.png';
export default function ServiceLibrarySeeWhatItsLike() {
    const { t: seeWhatItsLikeTexts } = useLocaleKeys('pages.servicesPage.seeWhatItsLike');
    return /*#__PURE__*/ _jsx(SeeWhatItsLike, {
        steps: [
            {
                title: seeWhatItsLikeTexts.step1Title(),
                subtitle: seeWhatItsLikeTexts.step1Subtitle(),
                image: {
                    src: img1,
                    height: 1246,
                    width: 702
                }
            },
            {
                title: seeWhatItsLikeTexts.sendUltimateProposal(),
                subtitle: seeWhatItsLikeTexts.step2Subtitle(),
                image: {
                    src: img2,
                    height: 1246,
                    width: 748
                }
            },
            {
                title: seeWhatItsLikeTexts.getApprovedFaster(),
                subtitle: seeWhatItsLikeTexts.step3Subtitle(),
                image: {
                    src: img3,
                    height: 1246,
                    width: 748
                }
            }
        ]
    });
}
